import { isObject } from "@perxis-auto/shared";
import { getCatalogCatalogGet, getEstimateEstimatePost, createReportReportsPost, getReportReportsReportIdGet } from "../../shared/api/services.gen.js";
import { WidgetType, ReportStatus } from "../../shared/api/types.gen.js";
import { ErrorStatusCode } from "../../shared/config/errors.js";
import { createAppAsyncThunk } from "../../shared/lib/store/createAppAsyncThunk.js";
import { isErrorStatusCode } from "../../shared/lib/utils/isErrorStatusCode.js";
import ApiService from "../../shared/services/ApiService.js";
import { selectConfig } from "../config/selectors.js";
import { selectFieldById, selectCurrentEntity as selectCurrentEntity$1 } from "../stages/selectors.js";
import { selectFieldIsMissingDependentFieldValuesById, selectDependFieldValuesByFieldId, selectCurrentEntity } from "./selectors.js";
const getOptions = createAppAsyncThunk(
  "forms/getOptions",
  async ({ fieldId, formId }, thunkAPI) => {
    var _a;
    try {
      const state = thunkAPI.getState();
      const { clientId } = selectConfig(state);
      const apiClient = ApiService.getInstance().client;
      const isMissingDependentFieldValues = selectFieldIsMissingDependentFieldValuesById(state, {
        fieldId,
        formId
      });
      const field = selectFieldById(state, {
        fieldId,
        formId
      });
      if (!field) {
        throw new Error(ErrorStatusCode.FORMS_GET_OPTIONS_NOT_FOUND_FIELD);
      }
      if ([WidgetType.INPUT, WidgetType.CHECKBOX].includes(field.widget)) {
        return;
      }
      if (isMissingDependentFieldValues) {
        throw new Error(ErrorStatusCode.FORMS_GET_OPTIONS_MISSING_DEPENDENT_FIELD_VALUES);
      }
      const dependFieldValues = selectDependFieldValuesByFieldId(state, { fieldId, formId });
      const getCatalogQuery = Object.entries(dependFieldValues || {}).reduce(
        (acc, [fieldId2, field2]) => {
          if (isObject(field2) && "id" in field2) {
            return {
              ...acc,
              [fieldId2]: field2.id
            };
          }
          return {
            ...acc,
            [fieldId2]: field2
          };
        },
        {}
      );
      const { data: catalogSchema } = await getCatalogCatalogGet({
        client: apiClient,
        query: {
          ...getCatalogQuery,
          field_id: fieldId
        },
        headers: {
          "X-Client-Id": clientId
        }
      });
      if (!catalogSchema || !((_a = catalogSchema.values) == null ? void 0 : _a.length)) {
        throw new Error(ErrorStatusCode.FORMS_GET_OPTIONS_NOT_FOUND_CATALOG_SCHEMA);
      }
      return {
        fieldId: catalogSchema.field_id,
        values: catalogSchema.values
      };
    } catch (error) {
      const statusCode = error instanceof Error && isErrorStatusCode(error.message) ? error.message : ErrorStatusCode.FORMS_GET_OPTIONS_DEFAULT;
      throw thunkAPI.rejectWithValue({
        statusCode,
        meta: {
          fieldId,
          formId
        }
      });
    }
  }
);
const submitForm = createAppAsyncThunk("forms/submitForm", async (_, thunkAPI) => {
  const state = thunkAPI.getState();
  const currentForm = selectCurrentEntity(state);
  const currentStage = selectCurrentEntity$1(state);
  try {
    if (!currentForm || !currentStage) {
      throw new Error(ErrorStatusCode.FORMS_SUBMIT_NOT_FOUND_CURRENT_FORM_OR_STAGE);
    }
    const ACTIONS_MAP = {
      // @ts-ignore
      "/trade-in/api/v1/reports/": getReport,
      // @ts-ignore
      "/trade-in/api/v1/estimate/": getEstimate
    };
    const action = ACTIONS_MAP[currentStage.form.handler];
    if (!action) {
      throw new Error(ErrorStatusCode.FORMS_SUBMIT_NOT_FOUND_ACTION);
    }
    const result = await thunkAPI.dispatch(action()).unwrap();
    return {
      formId: currentForm.id,
      result
    };
  } catch (error) {
    const statusCode = error instanceof Error && isErrorStatusCode(error.message) ? error.message : ErrorStatusCode.FORMS_SUBMIT_DEFAULT;
    throw thunkAPI.rejectWithValue({
      statusCode,
      meta: {
        formId: currentForm == null ? void 0 : currentForm.id
      }
    });
  }
});
const getEstimate = createAppAsyncThunk("forms/getEstimate", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { clientId } = selectConfig(state);
    const apiClient = ApiService.getInstance().client;
    const currentForm = selectCurrentEntity(state);
    const getEstimateBody = currentForm == null ? void 0 : currentForm.fields;
    const { data: estimateSchema } = await getEstimateEstimatePost({
      client: apiClient,
      body: getEstimateBody,
      headers: {
        "X-Client-Id": clientId
      }
    });
    if (!estimateSchema) {
      throw new Error(ErrorStatusCode.FORMS_GET_ESTIMATE_NOT_FOUND);
    }
    return estimateSchema;
  } catch (error) {
    const statusCode = error instanceof Error && isErrorStatusCode(error.message) ? error.message : ErrorStatusCode.FORMS_GET_ESTIMATE_DEFAULT;
    throw thunkAPI.rejectWithValue({
      statusCode
    });
  }
});
const getReport = createAppAsyncThunk("forms/getReport", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { clientId, report: reportConfig } = selectConfig(state);
    const apiClient = ApiService.getInstance().client;
    const currentForm = selectCurrentEntity(state);
    const createReportBody = currentForm == null ? void 0 : currentForm.fields;
    const { data: createReportSchema } = await createReportReportsPost({
      client: apiClient,
      body: createReportBody,
      headers: {
        "X-Client-Id": clientId
      }
    });
    if (!createReportSchema) {
      throw new Error(ErrorStatusCode.FORMS_GET_REPORT_FAILED_CREATE_REPORT_REQUEST);
    }
    let counter = 0;
    const preparedReport = await new Promise((resolve, reject) => {
      const getPreparedReport = async () => {
        try {
          const getReportPath = createReportSchema;
          const { data: reportSchema } = await getReportReportsReportIdGet({
            client: apiClient,
            path: getReportPath
          });
          if (!(reportSchema == null ? void 0 : reportSchema.report) || !(reportSchema == null ? void 0 : reportSchema.status) || ![ReportStatus.PROCESSING, ReportStatus.SUCCESS].includes(reportSchema.status)) {
            reject(new Error(ErrorStatusCode.FORMS_GET_REPORT_FAILED_GET_VEHICLE_REPORT));
            return;
          }
          if (reportSchema.status === ReportStatus.PROCESSING) {
            if (counter < reportConfig.attempts) {
              setTimeout(getPreparedReport, reportConfig.interval);
              return;
            }
            reject(new Error(ErrorStatusCode.FORMS_GET_REPORT_FAILED_GET_VEHICLE_REPORT));
          }
          resolve(reportSchema.report || []);
        } catch (e) {
          reject(new Error(ErrorStatusCode.FORMS_GET_REPORT_FAILED_GET_VEHICLE_REPORT));
        } finally {
          counter += 1;
        }
      };
      getPreparedReport();
    });
    return preparedReport;
  } catch (error) {
    const statusCode = error instanceof Error && isErrorStatusCode(error.message) ? error.message : ErrorStatusCode.FORMS_GET_REPORT_DEFAULT;
    throw thunkAPI.rejectWithValue({
      statusCode
    });
  }
});
export {
  getEstimate,
  getOptions,
  getReport,
  submitForm
};
